import { MessageSquare } from "lucide-react";
import { Trans, useTranslation } from "react-i18next";

export default function UsageHint() {
  const { t } = useTranslation();

  return (
    <div className="inline-flex items-center gap-2 rounded-lg border border-border/70 bg-muted/50 px-3 py-2 text-xs text-muted-foreground">
      <MessageSquare size={14} className="shrink-0" />
      <span>
        <Trans
          i18nKey="payments.usageHint"
          t={t}
          components={{
            code: (
              <code className="rounded font-mono border border-border bg-background px-1.5 py-px text-[11.5px] font-semibold text-foreground" />
            ),
          }}
        />
      </span>
    </div>
  );
}
